import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/connections',
      name: 'connections',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "connectionsPage" */ './views/connections-page.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/google',
      name: 'google',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/google-connect.vue')
    },
    {
      path: '/page/:slug?',
      name: 'uploadPage',
      props: true,
      component: () => import(/* webpackChunkName: "uploadPage" */ './views/form-page.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/login-page.vue'),
      meta: { unauthenticated: true }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import(/* webpackChunkName: "signupPage" */ './views/signup-page.vue'),
      meta: { unauthenticated: true }
    },
    {
      path: '/',
      name: 'pages',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "uploadPagesPage" */ './views/upload-pages-page.vue'),
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const unauthenticated = to.matched.some(record => record.meta.unauthenticated)

  const isAuthenticated = store.getters.isAuthenticated
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (unauthenticated && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
